<template>
  <div class="express-page">
    <header class="site-header">
      <div class="header-inner">
        <img src="../assets/logo.png" alt="U盾商城" class="logo" @click="toHome" />
        <nav class="nav-pc">
          <span class="nav-link" @click="toHome">首页</span>
          <span class="nav-link">查找订单</span>
          <span class="nav-link nav-member">
            会员中心
            <down-outlined class="nav-arrow" />
          </span>
        </nav>
        <button type="button" class="nav-mobile" aria-label="菜单" @click="menuOpen = !menuOpen">
          <span /><span /><span />
        </button>
      </div>
      <div v-if="menuOpen" class="mobile-menu">
        <span @click="toHome">首页</span>
        <span @click="menuOpen = false">查找订单</span>
        <span @click="menuOpen = false">会员中心</span>
      </div>
    </header>

    <main class="main">
      <div class="container">
        <p class="breadcrumb">
          <span class="link" @click="toHome">网站首页</span>
          <span class="sep">——</span>
          <span class="breadcrumb-text">未联系客服前勿拍本商品</span>
          <span class="sep breadcrumb-sep-extra">——</span>
          <span class="breadcrumb-text breadcrumb-extra">【补差价专用链接】请根据客服沟通指引下单，请勿乱拍</span>
        </p>

        <div class="layout">
          <div class="col-left">
            <div class="card product-card">
              <div class="product-media">
                <div v-if="detail.src" class="product-image-wrap">
                  <img :src="detail.src" alt="" class="product-banner" />
                </div>
                <div v-else class="info-icon-wrap">
                  <img src="../assets/desc.png" alt="" class="info-icon" />
                </div>
              </div>
              <div class="product-body">
                <h1 class="product-title">{{ detail.title }}</h1>

                <div class="tag-row mobile-only">
                  <span class="tag tag-blue">{{ detail.sendWay }}</span>
                  <span class="tag tag-red">库存 {{ detail.count }}</span>
                  <span class="tag tag-gold">销量 {{ detail.sell }}</span>
                </div>

                <div class="section-box qty-section">
                  <div class="qty-row">
                    <span class="label">购买数量：</span>
                    <div class="qty-stepper">
                      <button type="button" class="qty-btn" :disabled="inputNumber <= 1" @click="inputNumber--">
                        <minus-outlined />
                      </button>
                      <input
                        v-model.number="inputNumber"
                        class="qty-input"
                        type="text"
                        maxlength="6"
                        @input="onQtyInput"
                      />
                      <button type="button" class="qty-btn" @click="inputNumber++">
                        <plus-outlined />
                      </button>
                    </div>
                  </div>
                </div>

                <div class="section-box pay-section">
                  <div class="pay-row">
                    <p class="pay-label">选择支付方式</p>
                    <div class="pay-btn">
                      <img src="../assets/pay-way.png" alt="" class="pay-icon" />
                      <span>USDT 网关支付</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="card desc-card pc-desc">
              <div class="desc-head">
                <img src="../assets/desc.png" alt="" class="desc-icon" />
                <span>商品描述</span>
              </div>
              <div class="desc-body">{{ detail.detail || '' }}</div>
            </div>
          </div>

          <div class="col-right">
            <div class="card order-card">
              <p class="price order-price">${{ displayPrice.trim() }}</p>

              <template v-if="isExpressMode">
                <p class="form-title express-form-label">下单必要信息:</p>
                <a-input
                  v-model:value="expressForm.receiveQty"
                  class="form-input express-input"
                  placeholder="收货数量"
                  @update:value="onExpressQtyChange"
                />
                <a-input
                  v-model:value="expressForm.receiveAddress"
                  class="form-input express-input"
                  placeholder="收货地址"
                />
                <a-input
                  v-model:value="expressForm.phone"
                  class="form-input express-input"
                  placeholder="联系电话"
                />
                <a-input
                  v-model:value="expressForm.receiverName"
                  class="form-input express-input"
                  placeholder="收货人"
                />
              </template>

              <template v-else>
                <p class="form-title register-form-label">下单TG</p>
                <a-input v-model:value="form.tg" class="form-input register-input" placeholder="请输入TG" />
                <p class="form-tip">
                  游客购买后，查询订单信息需要用到 查单密码。登录用户无需填写此项
                </p>
              </template>

              <button type="button" class="buy-btn" @click="onBuy">
                <img src="../assets/car.png" alt="" class="buy-icon" />
                立即购买
              </button>
              <div class="contact-box">
                <img src="../assets/gift.png" alt="" class="contact-icon" />
                <span>遇到任何问题，请及时联系网站客服</span>
              </div>
            </div>

            <div class="card sales-card pc-only">
              <p class="sales-title">销售信息</p>
              <div class="sales-row">
                <div class="sales-icon-wrap">
                  <img src="../assets/count.png" alt="" />
                </div>
                <div class="sales-text">
                  <span class="sales-label">库存剩余</span>
                  <span class="sales-value">{{ detail.count }}</span>
                </div>
              </div>
              <div class="sales-row">
                <div class="sales-icon-wrap">
                  <img src="../assets/sell.png" alt="" />
                </div>
                <div class="sales-text">
                  <span class="sales-label">总销量</span>
                  <span class="sales-value">{{ detail.sell }}</span>
                </div>
              </div>
              <div class="sales-row">
                <div class="sales-icon-wrap">
                  <img src="../assets/send-way.png" alt="" />
                </div>
                <div class="sales-text">
                  <span class="sales-label">发货方式</span>
                  <span class="sales-value">{{ detail.sendWay }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="card desc-card mobile-desc">
          <div class="desc-head">
            <img src="../assets/desc.png" alt="" class="desc-icon" />
            <span>商品描述</span>
          </div>
          <div class="desc-body">{{ detail.detail || '暂无描述' }}</div>
        </div>
      </div>
    </main>

    <footer class="site-footer">
      <div class="footer-inner">
        <span class="beian">备案号</span>
        <span class="copyright">U盾商城 - 保留所有解释权。</span>
      </div>
    </footer>
  </div>
</template>

<script>
import { readReferralFromSearch, buildReferralQuery, attachGameGroupId } from '../util/deeplink';
import { DownOutlined, PlusOutlined, MinusOutlined } from '@ant-design/icons-vue';
import { addOrder } from '../util/api';
import { initSpecialProductPage, resolveLinkKey } from '../util/specialProduct';

const DEFAULT_PRODUCT = {
  title: '信息登记',
  sendWay: '自动发货',
  count: 999,
  sell: 999,
  price: 0.1,
};

export default {
  name: 'ExpressDelivery',
  components: {
    DownOutlined,
    PlusOutlined,
    MinusOutlined,
  },
  data() {
    return {
      menuOpen: false,
      referralCode: '',
      gameGroupId: '',
      linkKey: 'express',
      inputNumber: 1,
      form: {
        tg: '',
      },
      expressForm: {
        receiveQty: '',
        receiveAddress: '',
        phone: '',
        receiverName: '',
      },
      detail: { ...DEFAULT_PRODUCT },
      specialProduct: null,
    };
  },
  computed: {
    isExpressMode() {
      return this.linkKey === 'express';
    },
    displayPrice() {
      const p = Number(this.detail.price) || 0;
      if (p % 1 === 0) return ` ${p}`;
      const s = p.toFixed(2);
      return s.endsWith('0') ? ` ${p.toFixed(1)}` : ` ${s}`;
    },
  },
  async mounted() {
    const { referralCode, gameGroupId } = readReferralFromSearch(window.location.search);
    this.referralCode = referralCode;
    this.gameGroupId = gameGroupId;

    if (this.$route.params.data) {
      try {
        const data = JSON.parse(this.$route.params.data);
        this.detail = { ...DEFAULT_PRODUCT, ...data };
        if (data.referral_code) {
          this.referralCode = data.referral_code;
        }
        if (data.link_key) {
          this.linkKey = data.link_key;
        }
      } catch (e) {
        console.warn('parse route data failed', e);
      }
      return;
    }

    const linkKey = resolveLinkKey(this.$route) || 'express';
    this.linkKey = linkKey;
    await initSpecialProductPage(this, linkKey, {
      detailField: 'detail',
      fallback: {
        ...DEFAULT_PRODUCT,
        title: linkKey === 'register' ? '登记信息专用' : '实物快递',
      },
    });
    if (this.detail.link_key) {
      this.linkKey = this.detail.link_key;
    }
  },
  methods: {
    onExpressQtyChange(val) {
      this.expressForm.receiveQty = String(val ?? '').replace(/\D/g, '');
    },
    onQtyInput(e) {
      const v = String(e.target.value).replace(/\D/g, '');
      this.inputNumber = v ? Math.max(1, parseInt(v, 10)) : 1;
    },
    getExpressQty() {
      const n = parseInt(String(this.expressForm.receiveQty).replace(/\D/g, ''), 10);
      return Number.isFinite(n) && n > 0 ? n : 1;
    },
    buildExpressOrderNote() {
      const parts = [
        this.expressForm.receiverName,
        this.expressForm.phone,
        this.expressForm.receiveAddress,
      ]
        .map((s) => String(s || '').trim())
        .filter(Boolean);
      return parts.join(' / ');
    },
    toHome() {
      this.menuOpen = false;
      const q = buildReferralQuery(this.referralCode, this.gameGroupId);
      this.$router.push(Object.keys(q).length ? { path: '/', query: q } : '/');
    },
    getCurrentDateTime() {
      const date = new Date();
      const y = date.getFullYear();
      const m = String(date.getMonth() + 1).padStart(2, '0');
      const d = String(date.getDate()).padStart(2, '0');
      const h = String(date.getHours()).padStart(2, '0');
      const min = String(date.getMinutes()).padStart(2, '0');
      const s = String(date.getSeconds()).padStart(2, '0');
      return `${y}${m}${d}${h}${min}${s}`;
    },
    async onBuy() {
      const orderNo =
        this.getCurrentDateTime() +
        Math.floor(Math.random() * 100000)
          .toString()
          .padStart(6, '0');

      let payload;

      if (this.isExpressMode) {
        const receiveQty = this.getExpressQty();
        const orderNote = this.buildExpressOrderNote();
        payload = {
          ...this.detail,
          link_key: this.linkKey,
          referral_code: this.referralCode,
          inputNumber: this.inputNumber,
          receiveQty: String(receiveQty),
          receiveAddress: String(this.expressForm.receiveAddress || '').trim(),
          contactPhone: String(this.expressForm.phone || '').trim(),
          receiverName: String(this.expressForm.receiverName || '').trim(),
          tgAccount: orderNote,
          inputGT: orderNote,
          orderNo,
          src: '',
        };
      } else {
        const tg = (this.form.tg || '').trim();
        payload = {
          ...this.detail,
          link_key: this.linkKey,
          referral_code: this.referralCode,
          inputNumber: this.inputNumber,
          receiveQty: String(this.inputNumber),
          tgAccount: tg,
          inputGT: tg,
          orderNo,
          src: '',
        };
      }

      await addOrder(payload);
      this.$router.push({
        name: 'ExpressPayment',
        params: { data: JSON.stringify(attachGameGroupId(payload, this.gameGroupId)) },
      });
    },
  },
};
</script>

<style scoped lang="less">
@blue: #1890ff;
@blue-dark: #1677ff;
@bg-page: #d9ebf8;
@text-muted: #666;
@warn-red: #e7473c;
@card-radius: 12px;
@shadow: 0 4px 18px rgba(100, 150, 200, 0.16);
@border-soft: #e8edf5;

.express-page {
  min-height: 100vh;
  min-height: 100dvh;
  overflow-x: hidden;
  background: linear-gradient(180deg, #c8e4f8 0%, #d9ebf8 40%, #e8f4fc 100%);
  display: flex;
  flex-direction: column;
}

/* Header */
.site-header {
  background: #fff;
  border-bottom: 1px solid #edf2fa;
  position: sticky;
  top: 0;
  z-index: 100;
}

.header-inner {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.logo {
  height: 40px;
  width: auto;
  cursor: pointer;
}

.nav-pc {
  display: flex;
  align-items: center;
  gap: 36px;
  font-size: 16px;
  color: #333;

  .nav-link {
    cursor: pointer;
    line-height: 60px;

    &:hover {
      color: @blue;
    }
  }

  .nav-member {
    display: inline-flex;
    align-items: center;
    gap: 4px;
  }

  .nav-arrow {
    font-size: 12px;
    color: #999;
  }
}

.nav-mobile {
  display: none;
  flex-direction: column;
  justify-content: center;
  gap: 5px;
  width: 36px;
  height: 36px;
  padding: 6px;
  border: none;
  background: transparent;
  cursor: pointer;

  span {
    display: block;
    height: 2px;
    background: #666;
    border-radius: 1px;
  }
}

.mobile-menu {
  display: none;
  flex-direction: column;
  padding: 12px 20px 16px;
  border-top: 1px solid #edf2fa;
  background: #fff;
  gap: 12px;
  font-size: 15px;
  color: #333;

  span {
    cursor: pointer;
  }
}

/* Main */
.main {
  flex: 1;
  padding: 16px 0 32px;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 16px;
}

.breadcrumb {
  font-size: 13px;
  line-height: 22px;
  color: #333;
  margin: 0 0 16px;
  word-break: break-word;

  .link {
    cursor: pointer;
    color: #333;
    white-space: nowrap;

    &:hover {
      color: @blue;
    }
  }

  .breadcrumb-text {
    display: inline;
  }

  .sep {
    color: #d9d9d9;
    margin: 0 4px;
    white-space: nowrap;
  }
}

.layout {
  display: flex;
  gap: 20px;
  align-items: flex-start;
}

.col-left {
  flex: 1;
  min-width: 0;
}

.col-right {
  width: 320px;
  flex-shrink: 0;
}

.card {
  background: #fff;
  border-radius: @card-radius;
  box-shadow: @shadow;
}

/* Product card */
.product-card {
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.product-media {
  width: 100%;
}

.product-image-wrap {
  width: 100%;
  border-radius: 8px;
  overflow: hidden;
  background: #f5f5f5;

  .product-banner {
    width: 100%;
    height: auto;
    display: block;
    object-fit: cover;
    max-height: 240px;
  }
}

.info-icon-wrap {
  width: 100%;
  aspect-ratio: 1;
  max-width: 200px;
  margin: 0 auto;
  background: #1a1a1a;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.info-icon {
  width: 56%;
  height: 56%;
  object-fit: contain;
  filter: brightness(0) invert(1);
}

.product-body {
  width: 100%;
  min-width: 0;
}

.product-title {
  margin: 0;
  font-size: 20px;
  font-weight: 700;
  color: @blue;
  line-height: 1.4;
  text-align: left;
}

.section-box {
  margin-top: 14px;
  padding: 12px 14px;
  border: 1px solid @border-soft;
  border-radius: 8px;
  background: #fff;
}

.qty-section {
  margin-top: 12px;
}

.pay-section {
  .pay-row {
    margin-top: 0;
  }
}

.tag-row {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 12px;
  justify-content: flex-start;
}

.tag {
  padding: 2px 12px;
  border-radius: 20px;
  font-size: 13px;
  border: 1px solid;
}

.tag-blue {
  color: @blue;
  border-color: @blue;
}

.tag-red {
  color: @warn-red;
  border-color: @warn-red;
}

.tag-gold {
  color: #d4a017;
  border-color: #d4a017;
}

.qty-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;

  .label {
    color: @text-muted;
    font-size: 14px;
    flex-shrink: 0;
  }
}

.qty-stepper {
  display: flex;
  align-items: center;
  gap: 0;
}

.qty-btn {
  width: 32px;
  height: 32px;
  border: none;
  background: @blue;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 14px;

  &:disabled {
    background: #bfbfbf;
    cursor: not-allowed;
  }

  &:first-child {
    border-radius: 4px 0 0 4px;
  }

  &:last-child {
    border-radius: 0 4px 4px 0;
  }
}

.qty-input {
  width: 72px;
  height: 32px;
  text-align: center;
  border: 1px solid #d9d9d9;
  border-left: none;
  border-right: none;
  outline: none;
  font-size: 14px;
}

.pay-row {
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  .pay-label {
    margin: 0 0 10px;
    font-size: 14px;
    color: #333;
  }
}

.pay-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: auto;
  max-width: 100%;
  height: 38px;
  padding: 0 14px;
  background: @blue;
  border-radius: 6px;
  color: #fff;
  font-size: 13px;
  cursor: default;
  white-space: nowrap;
  flex-shrink: 0;

  .pay-icon {
    width: 18px;
    height: 18px;
    margin-right: 8px;
  }
}

/* Description */
.desc-card {
  margin-top: 20px;
  overflow: hidden;
}

.desc-head {
  background: @blue;
  color: #fff;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 15px;
  font-weight: 500;

  .desc-icon {
    width: 18px;
    height: 18px;
    filter: brightness(10);
  }
}

.desc-body {
  padding: 16px 20px 20px;
}

.mobile-desc {
  display: none;
}

.pc-desc {
  display: block;
}

/* Order card */
.order-card {
  padding: 18px 16px 20px;
}

.price {
  margin: 0 0 16px;
  font-size: 32px;
  font-weight: 700;
  color: @blue;
  line-height: 1.1;
}

.form-title {
  margin: 0 0 12px;
  font-size: 14px;
  color: @text-muted;
}

.express-form-label,
.register-form-label {
  margin-bottom: 12px;
  font-weight: 400;
}

.form-input {
  margin-bottom: 10px;
  height: 44px;
  border-radius: 8px;
  background: #f2f2f2 !important;
  border-color: transparent !important;

  :deep(.ant-input) {
    font-size: 16px;
    background: transparent;
  }
}

.express-input:last-of-type,
.register-input {
  margin-bottom: 0;
}

.form-tip {
  margin: 12px 0 16px;
  font-size: 12px;
  color: @text-muted;
  line-height: 1.6;
}

.buy-btn {
  width: 100%;
  height: 48px;
  border: none;
  border-radius: 6px;
  background: @blue;
  color: #fff;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  cursor: pointer;

  &:hover {
    background: @blue-dark;
  }

  .buy-icon {
    width: 20px;
    height: 20px;
  }
}

.contact-box {
  margin-top: 16px;
  padding: 14px;
  background: #e8f3ff;
  border-radius: 6px;
  display: flex;
  align-items: flex-start;
  gap: 10px;
  font-size: 13px;
  color: #333;
  line-height: 1.5;

  .contact-icon {
    width: 20px;
    height: 20px;
    flex-shrink: 0;
  }
}

/* Sales */
.sales-card {
  margin-top: 16px;
  padding: 16px 20px;
}

.sales-title {
  margin: 0 0 16px;
  font-size: 14px;
  color: #888;
}

.sales-row {
  display: flex;
  align-items: center;
  margin-bottom: 14px;

  &:last-child {
    margin-bottom: 0;
  }
}

.sales-icon-wrap {
  width: 34px;
  height: 34px;
  background: #f5f8fc;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;

  img {
    width: 16px;
    height: 16px;
  }
}

.sales-text {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.sales-label {
  font-size: 13px;
  color: #333;
}

.sales-value {
  font-size: 14px;
  color: @blue;
  font-weight: 500;
}

/* Footer */
.site-footer {
  background: #fff;
  border-top: 1px solid #edf2fa;
  padding: 14px 0;
}

.footer-inner {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  color: #666;
}

.beian {
  padding: 4px 12px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  color: @blue;
  font-size: 13px;
}

.mobile-only {
  display: none;
}

.pc-only {
  display: block;
}

/* Desktop layout */
@media (min-width: 769px) {
  .product-card {
    flex-direction: row;
    padding: 20px;
    gap: 24px;
  }

  .product-media {
    flex: 0 0 280px;
    max-width: 42%;
  }

  .product-image-wrap .product-banner {
    max-height: 280px;
    border-radius: 10px;
  }

  .product-title {
    font-size: 22px;
    text-align: left;
  }

  .section-box {
    margin-top: 16px;
  }
}

/* Mobile */
@media (max-width: 768px) {
  .nav-pc {
    display: none;
  }

  .nav-mobile {
    display: flex;
  }

  .mobile-menu {
    display: flex;
  }

  .header-inner {
    height: 52px;
    padding: 0 12px;
  }

  .logo {
    height: 34px;
  }

  .main {
    padding: 12px 0 24px;
  }

  .container {
    max-width: 100%;
    padding: 0 12px;
  }

  .layout {
    flex-direction: column;
    gap: 12px;
    width: 100%;
  }

  .col-left,
  .col-right {
    width: 100%;
    flex: none;
  }

  .breadcrumb {
    display: none;
  }

  .col-left .product-card {
    border-radius: @card-radius;
    box-shadow: @shadow;
    padding: 16px;
    gap: 14px;
    overflow: hidden;
  }

  .col-left .product-image-wrap {
    border-radius: 10px;

    .product-banner {
      width: 100%;
      min-height: 180px;
      max-height: 240px;
      object-fit: cover;
      border-radius: 10px;
    }
  }

  .col-left .info-icon-wrap {
    width: 100%;
    max-width: none;
    aspect-ratio: 4 / 3;
    min-height: 180px;
    border-radius: 10px;
    background: #f0f0f0;
  }

  .col-left .product-title {
    font-size: 20px;
    font-weight: 700;
    text-align: left;
    margin-top: 4px;
    padding: 0;
  }

  .col-left .tag-row {
    justify-content: flex-start;
    flex-wrap: wrap;
    gap: 8px;
    margin-top: 12px;
  }

  .col-left .tag {
    padding: 3px 12px;
    font-size: 12px;
    background: #fff;
  }

  .col-left .section-box {
    margin-top: 14px;
    padding: 12px 14px;
    border: 1px solid #dce6f2;
    border-radius: 8px;
    background: #fff;
  }

  .col-left .qty-section {
    margin-top: 14px;
  }

  .col-left .qty-row {
    justify-content: space-between;
    align-items: center;
    width: 100%;
    flex-wrap: nowrap;
    gap: 12px;

    .label {
      font-size: 14px;
      color: #333;
    }
  }

  .col-left .qty-stepper {
    flex-shrink: 0;
  }

  .col-left .qty-btn {
    width: 36px;
    height: 36px;
    font-size: 14px;
  }

  .col-left .qty-input {
    width: 56px;
    height: 36px;
    font-size: 15px;
    background: #fff;
  }

  .col-left .pay-section .pay-row {
    align-items: flex-start;
    width: 100%;
  }

  .col-left .pay-section .pay-label {
    margin-bottom: 10px;
    font-size: 14px;
    color: #333;
  }

  .col-left .pay-btn {
    display: inline-flex;
    width: auto;
    height: 36px;
    padding: 0 12px;
    border-radius: 6px;
    font-size: 13px;
  }

  .col-right .order-card,
  .mobile-desc {
    border-radius: @card-radius;
    box-shadow: @shadow;
  }

  .card {
    width: 100%;
  }

  .mobile-only {
    display: flex;
  }

  .pc-only,
  .pc-desc,
  .sales-card {
    display: none !important;
  }

  .mobile-desc {
    display: block;
    margin-top: 10px;
    width: 100%;
  }

  .desc-body {
    font-size: 14px;
    line-height: 1.7;
    color: #444;
    word-break: break-word;
  }

  .order-card {
    padding: 16px 14px 18px;
  }

  .order-price {
    display: block;
    font-size: 34px;
    margin-bottom: 14px;
  }

  .buy-btn {
    height: 46px;
    font-size: 16px;
    margin-top: 16px;
  }

  .contact-box {
    font-size: 12px;
    padding: 12px;
  }

  .footer-inner {
    flex-direction: column;
    gap: 10px;
    text-align: center;
    font-size: 12px;
    padding: 0 12px;
  }
}

@media (max-width: 380px) {
  .product-title {
    font-size: 17px;
  }

  .order-price {
    font-size: 30px;
  }
}
</style>
